<figcaption class="tt-c-pinboard-comment">
  <span class="tt-c-pinboard-comment__text">{{commentText}}<template v-if="isTextTruncated">&hellip; </template><tt-button v-if="isTextTruncated" type="link" class="tt-c-pinboard-comment__text-expand" @click.prevent="expandComment" v-html="$msg('commentsPinboardItem.readMore')"></tt-button></span>
  <span class="tt-c-pinboard-comment__author">{{author}}<template v-if="isUserNameTruncated">&hellip;</template></span>
  <span class="tt-c-pinboard-comment__timestamp" v-html="elapsedTime"></span>
</figcaption>



// WEBPACK FOOTER //
// ./src/components/pinboard/pinboard-comment.html